import { render, staticRenderFns } from "./AbsencesTeacher.vue?vue&type=template&id=561ad5b1"
import script from "./AbsencesTeacher.vue?vue&type=script&lang=js"
export * from "./AbsencesTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports